import { render } from "./registrationPage.vue?vue&type=template&id=08f10200"
import script from "./registrationPage.vue?vue&type=script&lang=js"
export * from "./registrationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__